import { Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '@app/auth/auth/auth.service';
import { EMAIL } from '@app/servicios/util.service';
import { Router } from '@angular/router';
import { TokenService } from '@app/auth/auth/token.service';
import { AdminService } from '@app/servicios/admin/admin.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  
})
export class LoginComponent {
  private fb = inject(FormBuilder);
  private authService = inject(AuthService);
  private router = inject(Router);
  public loginError = false;
  public loginErrorMsj = '';

  public loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, EMAIL]],
    password: ['', [Validators.required, Validators.minLength(6)]],
  });

  constructor(
    private tokenService: TokenService,
    private adminService: AdminService
  ) {}

  login() {
    this.loginError = false;
    const { email, password } = this.loginForm.value;
  
    this.authService.login(email, password).subscribe(
      (resp) => {
        if (resp.codigoRespuesta === '00') {
          if (resp.data.userTipo === 'EMPLEADO') {
            this.loginError = true;
            this.loginErrorMsj = 'Su usuario no tiene permisos para acceder. Contacte al administrador';
            this.tokenService.logOut();
            return;
          }
  
          this.adminService.consultarMonto();
          this.tokenService.setToken(resp.data.token);
          this.router.navigateByUrl('/espacio-mayorista/tienda2/all/all/all/0');
        } else if (resp.codigoRespuesta === '012') {
          this.tokenService.logOut();
          this.loginError = true;
          this.loginErrorMsj = 'Usuario inactivo. Contacte al administrador';
        }
      },
      (err) => {
        this.tokenService.logOut();
        const code = err?.error?.codigoRespuesta;
  
        if (code === '013') {
          this.loginError = true;
          this.loginErrorMsj = 'Existe más de un usuario con este correo. Contacte al administrador';
        } else if (code === '012') {
          this.loginError = true;
          this.loginErrorMsj = 'Usuario inactivo. Contacte al administrador';
        } else {
          this.loginError = true;
          this.loginErrorMsj = 'Usuario y/o contraseña incorrectos';
        }
      }
    );
  }

  validarSesion() {
    if (this.tokenService.isLoggedIn()) {
      this.router.navigateByUrl('/espacio-mayorista/tienda2/all/all/all/0');
    }
  }
}
